"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageLang = void 0;
const fdr_lib_i18n_lang_config_1 = require("@hotelplan/fdr.lib.i18n.lang-config");
function getPageLang(language) {
    return (language || fdr_lib_i18n_lang_config_1.languageDefault).toUpperCase();
}
exports.getPageLang = getPageLang;
//# sourceMappingURL=get-page-lang.js.map